import { releaseStepTime } from "@repo/domain";
import type { PresentedOrderSetDto } from "@/lib/order-set-presentation";

/** Withdraw held procedure work in place; discard additions that have not been saved. */
export function removeFromOrderSet(
  set: PresentedOrderSetDto,
  id: string,
  held: ReadonlySet<string>,
): PresentedOrderSetDto {
  const change = <T extends { orderId: string }>(items: readonly T[]): T[] =>
    held.has(id)
      ? items.map((item) => (item.orderId === id ? { ...item, status: "revoked" } : item))
      : items.filter((item) => item.orderId !== id);
  const steps = set.steps.map((step) => ({ ...step, orders: change(step.orders) }));
  const removed = new Set(
    steps.flatMap((step, index) =>
      (step.orders.length > 0 || set.steps[index]?.orders.length) &&
      step.orders.every((order) => order.status === "revoked") &&
      step.placement.durationMinutes > 0
        ? [index]
        : [],
    ),
  );
  const released = releaseStepTime(steps, removed, set.envelopeMinutes);
  return {
    ...set,
    ...released,
    authoredEnvelopeMinutes: released.envelopeMinutes,
    durationMinutes: released.envelopeMinutes,
    steps: released.steps.filter((step) => step.orders.length > 0 || held.has(step.stepId)),
    orders: change(set.orders),
  };
}
